{
    "Policies_Incomplete.search.assignedTo": "FR: Assigned To",
    "Policies_Incomplete.search.allBrokers": "FR: All Brokers",
    "Policies_Incomplete.search.allProducts": "FR: All Products",
    "Policies_Incomplete.search.phone": "FR: Phone",
    "Policies_Incomplete.search.email": "FR: Email",
    "Policies_Incomplete.search.clear": "FR: Clear",

    "Policies_Incomplete.table.referenceNumber": "FR: Reference Number",
    "Policies_Incomplete.table.policyNumber": "FR: Policy Number",
    "Policies_Incomplete.table.name": "FR: Name",
    "Policies_Incomplete.table.product": "FR: Product",
    "Policies_Incomplete.table.creationDate": "FR: Creation Date",
    "Policies_Incomplete.table.assignedTo": "FR: Assigned To",
    "Policies_Incomplete.table.type": "FR: Type",
    "Policies_Incomplete.search.fname": "FR: First Name",
    "Policies_Incomplete.search.lname": "FR: Last Name",
    "Policies_Incomplete.search.search": "FR: Search"
}
